/**
 * The server's cap on a rendered alert (`MAX_RENDERED_LENGTH`).
 *
 * Duplicated here rather than imported, for the same boundary reason as
 * `preview.ts`, and held against the package by the same test. The preview
 * truncates at the same point the product does, so an operator sees the cut
 * rather than meeting it later.
 */
export const MAX_PREVIEW_LENGTH = 500;
